<!--
@component Selector as a set of buttons.

   Main properties:
   - `options` - array with options (strings).
   - `value` - the selected value (string, bindable), default - the first option.
   - `className` - additional class name for building customized selects.
-->
<script>
   let {
      options,                         // array with all options
      value = $bindable(options[0]),   // initial selected value
      className = '',                  // extra class name
   } = $props();

   /**
    * Handler of event when changes are made by pressing left and right arrows
    * @param e
    */
   const changeOption = (e) => {
      if (e.key === 'ArrowLeft') {
         const ind = options.findIndex(v => v === value);
         if (ind > 0) {
            value = options[ind - 1];
         }
         return
      }

      if (e.key === 'ArrowRight') {
         const ind = options.findIndex(v => v === value);
         if (ind < options.length - 1) {
            value = options[ind + 1];
         }
         return
      }
   }

</script>

<div onkeydown={changeOption} role="radiogroup" tabindex="0" class="selector {className}">
   {#each options as option (option)}
   <button tabindex="-1" onclick={() => value = option} class="option option_{option.toString().replace('.', '_')}" class:selected={option==value}>
   {@html option}
   </button>
   {/each}
</div>
<input bind:value={value}>

<style>
   input {
      display: none;
   }

   .selector {
      position: relative;
      box-sizing: border-box;
      flex: 1 1 auto;
      font-size: 1em;
      line-height: 1.5em;
      margin: 0;
      padding: 0;
      width: auto;
      border-radius: 2px;
      user-select: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      display: flex;
   }

   .selector:focus-visible {
      outline: solid 2px;
      outline-offset: 2px;
   }

   .option {
      cursor: default;
      padding: 0.25em 0.5em;
      margin: 0 0.3em 0 0;
      border: 1px solid transparent;
      border-radius: 0.3em;
      font-size: 0.85em;
   }


   .option:not(.selected):hover {
      border: 1px solid;
   }
</style>
